'use strict';

import angular from 'angular';

function FinTxnResource($resource) {
  return $resource('/api/groups/:groupId/financialtransactions/:id/:controller',
    {
      groupId: '@groupId',
      id: '@id'
    }, {
      queryMembers: {
        method: 'GET',
        params: {controller: 'members'},
        isArray: true
      },
      queryReport: {
        method: 'GET',
        isArray: true,
        params: { controller: 'report' }
      },
      submit: {
        method: 'POST',
        params: {controller: 'submit'},
      },
      finalize: {
        method: 'POST',
        params: {controller: 'finalize'},
      },
      accept: {
        method: 'POST',
        params: {controller: 'accept'},
      },
      reject: {
        method: 'POST',
        params: {controller: 'reject'},
      },
      setPostDate: {
        method: 'POST',
        params: {controller: 'setpostdate'},
      },
      update: { method: 'PUT' }
    });
}

FinTxnResource.$inject = ['$resource'];

export default angular.module('georgeApp.finTxnSvc', [])
  .factory('FinTxnSvc', FinTxnResource)
  .name;
